import _ from 'lodash';
import { PatientFormTemplate } from 'requests/resources';

import {
  PatientFormTemplateItem,
  PatientFormTemplateItemTypeKeys,
  PatientFormTemplateLumaBotFlow,
} from '@lib/resources/types';
import { getAnswerDefaults, getItemDefaults } from '@lib/services/patientFormTemplatesService';

import { generateMessageTemplateKey } from 'hooks';

const getErrorTitle = (itemType?: PatientFormTemplateItemTypeKeys) => {
  if (itemType === 'scheduler') return generateMessageTemplateKey('patientLumaBotSchedulerError');
  if (itemType === 'manageAppointment') return generateMessageTemplateKey('patientLumaBotManageAppointmentError');
  return 'Unfortunately something went wrong, please try again later.';
};

/*
 * We're going to move this error message handling to BE
 */

export const getLumaBotErrorMessageHandler = (
  flowTemplates?: PatientFormTemplate[],
  itemType?: PatientFormTemplateItemTypeKeys,
): PatientFormTemplateItem => ({
  ...getItemDefaults('multiple_choice', 'intake', true),
  title: getErrorTitle(itemType),
  properties: {
    answers: [
      {
        ...getAnswerDefaults(),
        label: generateMessageTemplateKey('patientLumaBotSpeakWithStaff'),
        redirectType: 'goToForm',
        properties: {
          goToForm: _.find(flowTemplates, {
            lumaBotFlow: PatientFormTemplateLumaBotFlow.SpeakWithStaff,
          })?._id,
        },
      },
    ],
  },
});
